import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "hamburger-menu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  id: "menu__toggle",
  type: "checkbox"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "menu__btn",
  for: "menu__toggle"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_4 = { class: "menu__box" }
const _hoisted_5 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerSections, (section, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("a", {
            class: "default-text-header menu__item",
            href: section.url,
            target: section.target
          }, _toDisplayString(section.text), 9, _hoisted_5)
        ]))
      }), 128))
    ])
  ]))
}